import React from 'react';
import ServiceCard from '../components/ServiceCard';
import { FaTools, FaGem, FaBomb } from 'react-icons/fa';
import './Services.css';

function Services() {
  const services = [
    {
      id: 1,
      icon: FaTools,
      title: 'Construction Technology',
      description: 'We focus on integrating advanced technological solutions into the construction industry to improve efficiency, safety, and sustainability. The goal is to streamline construction processes, reduce costs, enhance collaboration, and deliver higher quality projects while minimizing environmental impact.',
      features: ['Process Optimization', 'Safety Management', 'Cost Reduction', 'Quality Assurance', 'Real-time Monitoring', 'Data Analytics'],
      benefits: [
        'Reduced construction time by 30%',
        'Cost savings through efficient planning',
        'Enhanced team collaboration',
        'Improved project transparency',
        'Better resource management'
      ]
    },
    {
      id: 2,
      icon: FaGem,
      title: 'Mining & Mining Support',
      description: 'We provide essential assistance to the mining industry by offering specialized services to enhance mining operations. These services include drilling, blasting, equipment maintenance, transportation, & technical consultation. We help with exploration, logistics, safety management, & environmental compliance.',
      features: ['Drilling Services', 'Equipment Maintenance', 'Logistics Support', 'Environmental Compliance', 'Safety Management', 'Exploration Support'],
      benefits: [
        'Increased mining efficiency',
        'Reduced operational costs',
        'Enhanced safety protocols',
        'Environmental compliance',
        'Expert technical support',
        'Sustainable operations'
      ]
    },
    {
      id: 3,
      icon: FaBomb,
      title: 'Special Rock Drilling & Blasting',
      description: 'We are knowledgeable in the geology of different rock types, explosives handling, and the engineering principles of controlled blasting. Our work is critical in mining, construction, and infrastructure projects, ensuring that rock removal is conducted efficiently while minimizing risks to workers, equipment, and surrounding environments.',
      features: ['Precision Blasting', 'Geological Analysis', 'Risk Management', 'Regulatory Compliance', 'Safety Protocols', 'Advanced Equipment'],
      benefits: [
        'Precise rock removal',
        'Minimized environmental impact',
        'Worker safety assurance',
        'Equipment protection',
        'Regulatory compliance',
        'Professional expertise'
      ]
    }
  ];

  return (
    <main className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive engineering solutions for all your construction, mining, and drilling needs</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Our Service Offerings</h2>
            <p>Industry-leading expertise in engineering and construction technology</p>
          </div>

          <div className="grid grid-3">
            {services.map(service => (
              <div key={service.id}>
                <ServiceCard service={service} />
                <div className="service-benefits">
                  <h4>Why Choose This Service?</h4>
                  <ul>
                    {service.benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-cta" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <h2>Need a Custom Solution?</h2>
          <p>Our team can tailor our services to meet your specific project requirements</p>
          <a href="https://wa.me/+2348034648000" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            Contact Our Team
          </a>
        </div>
      </section>
    </main>
  );
}

export default Services;
